<ng-container *ngIf="regionState$ | async as state">
  <ng-container *ngIf="regionService.regionSupportedInChannels(state.region); else NO_SUPPORT">
    <div class="message" xColor="warn">
      <ng-container i18n="@@RegionOverlay.GotoChannel.DeliveryRegion">Delivery region</ng-container>
      <strong>{{ state.region?.name }}</strong>
      <ng-container i18n="@@RegionOverlay.OutsideCurrentChannel.Note">
        is outside of your current channel.
      </ng-container>
    </div>

    <button mat-flat-button color="primary" (click)="regionService.gotoChannel(state)">
      Go to {{ state.region?.channelCode }} channel
    </button>
  </ng-container>

  <ng-template #NO_SUPPORT>
    <div class="message" xColor="warn" *ngIf="state.region">
      <ng-container i18n="@@RegionOverlay.GotoChannel.DeliveryRegion">Delivery region</ng-container>
      <strong>{{ state.region.name }}</strong>
      <ng-container i18n="@@RegionOverlay.OutsideCurrentChannelAndNotSupported.Note">
        is outside of your current channel and not in any channels we support currently.
      </ng-container>
    </div>
  </ng-template>
</ng-container>
